import { useEffect } from "react"
import { Outlet, useLocation } from "react-router-dom"
import { useDispatch } from "react-redux"
import Header from "../src/comp/Component/Header"
import Footer from "../src/Component/Home/Footer"
import { Toaster } from "react-hot-toast"

import fetchUserDetails from "./comp/Utils/fetchUserDetail"
import { setAllCategory } from "./comp/Store/ProductSlice"
import { setUserDetails } from "./comp/Store/Userslice"
import Axios from "./comp/Utils/axios"
import SummaryAPI from "./comp/Commson/summaryApi"

import "./App.css"

const App = () => {
  const dispatch = useDispatch()
  const location = useLocation()

  const fetchUser = async () => {
    const userData = await fetchUserDetails()
    if (userData) dispatch(setUserDetails(userData))
  }

  const fetchCategory = async () => {
    try {
      const response = await Axios({ ...SummaryAPI.getAllCategories })
      if (response?.data?.success) {
        dispatch(setAllCategory(response.data.data))
      }
    } catch (error) {
      console.error("Category fetch error", error)
    }
  }

  // Initial load
  useEffect(() => {
    fetchUser()
    fetchCategory()
  }, [])

  // Meta Pixel page view on route change
  useEffect(() => {
    if (window.fbq) {
      window.fbq("track", "PageView")
    }
  }, [location.pathname])

  return (
    <div className="min-h-screen flex flex-col bg-white overflow-x-hidden">
      
      {/* Header */}
      <header className="sticky top-0 z-50 w-full bg-white shadow-sm">
        <Header />
      </header>

      {/* Main Content */}
      <main className="flex-1 w-full">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="w-full bg-gray-50 border-t border-gray-200">
        <Footer />
      </footer>

      {/* Toast */}
      <Toaster
        position="top-right"
        toastOptions={{
          className: "text-sm",
        }}
      />
    </div>
  )
}

export default App
